export default __webpack_public_path__ + "static/media/margin-notes.2664d3db.png";